<template>
  <div class="line-wrapper" :class="{ horizontal }">
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  props: {
    horizontal: Boolean
  }
}
</script>

<style lang="scss" scoped>
.line-wrapper {
  .line {
    height: 100%;
    width: 1px;
    background: var(--r-white-4);
  }

  &.horizontal {
    .line {
      width: 100%;
      height: 1px;
    }
  }
}
</style>
